import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import IconClose from '@mui/icons-material/Close';

const AlertComponent = (props) => {

    const renderClose = (
        <IconButton sx={{p:0,py:0.5,ml:1}} onClick={props?.handleSuccessSnackbarClose}>
            <IconClose sx={{color:'white', fontSize:20}}/>
        </IconButton>
    )

    const action = (
        props?.isDisplayDrillDownButton ? <><Button variant="contained" sx={{p:0.7,lineHeight:'normal'}}
        onClick={(e) => onClick(e, props?.drillDownButtonURL)} color="secondary" size="small">
            Drill Down
        </Button>
        {renderClose}
        </>
        : <>{renderClose}</>
    )

    const onClick = (e, _url) => {
        e.preventDefault();
        window.open(_url, '_blank')
    }

    return (
        <>
            {props?.isSuccessSnackbarOpen &&
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={props?.isSuccessSnackbarOpen}
                    autoHideDuration={3000}
                    onClose={props?.handleSuccessSnackbarClose}
                >
                    <Alert onClose={props?.handleSuccessSnackbarClose} severity="success" sx={{ width: '100%', marginTop: "30px" }} action={action}>
                    {(props?.drillDownButtonURL && !props?.isDisplayDrillDownButton)
                        ? <a style={{ color: 'white' }} href={props?.drillDownButtonURL} onClick={(e) => onClick(e, props?.drillDownButtonURL)}>{props?.successSnackbarMessage}</a>
                        : props?.successSnackbarMessage
                    }
                    </Alert>
                </Snackbar> 
            }
            {props?.isErrorSnackbarOpen &&
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={props?.isErrorSnackbarOpen}
                    autoHideDuration={3000}
                    onClose={props?.handleErrorSnackbarClose}
                >
                    <Alert onClose={props?.handleErrorSnackbarClose} severity="error" sx={{ width: '100%', marginTop: "30px" }}>
                        {props?.errorSnackbarMessage}
                    </Alert>
                </Snackbar>
            }
      </>
    )
}

export default AlertComponent;